import type { ReactNode } from 'react';

interface HeaderProps {
    logo?: ReactNode;
    search?: ReactNode;
    actions?: ReactNode;
    className?: string;
}

function Header({ logo, search, actions, className = '' }: HeaderProps) {
    return (
        <header
            className={`flex w-full flex-row items-center justify-between bg-white p-2 py-3 text-sm shadow-sm md:flex-row ${className}`}
        >
            <div className="mb-2 flex w-full justify-start md:mb-0 md:ml-5 md:w-1/3">{logo}</div>

            <div className="mr-3 flex w-full justify-center md:w-1/3">{search}</div>

            <div className="mr-5 flex w-full items-center justify-end gap-2 md:w-1/3">{actions}</div>
        </header>
    );
}

export default Header;
